const CustomizedSolution = () => {
    return (
      <div>
  
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Customised Solutions
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS is the most trusted name in the country with a reputation for dedication to delivering a comprehensive 
              range of logistics services. Our strategically located logistics hubs and the largest countrywide network 
              with real-time communications twenty-four hours a day, we provide high-quality logistics solutions for 
              small to medium-sized companies and large corporations across every industry.
            </p>
              
          </div>
          <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
              <img src="/overland/Customize-Solutions-Inside.jpg" alt="" className="max-w-[100%] rounded-md"/>
          </div>
          </div>
      
      </div>
    </div>
    );
  };
  
  export default CustomizedSolution;
  